module.exports = __webpack_public_path__ + "img/Hand_31_05_28.cbb5d71b.png";